// @flow
import React from 'react';
import compact from 'lodash/compact';
import Check from 'assets/icons/check.svg';

const RATING = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
];

const RATING_KEY = { left: 'Poor', right: 'Excellent' };

const formatCreateReport = (
  isCanceled: boolean,
  fullName: string,
  showSessionReportRatingField: boolean = true,
) => {
  const HEADLINE = isCanceled ? 'Anything else you want to add?' : 'How was the session?';

  const RATINGS_FIELD = {
    columns: { small: 1, large: 1 },
    fields: [
      {
        type: 'rating',
        name: 'sessionReportRating',
        values: RATING,
        icon: <Check />,
        ratingKey: RATING_KEY,
      },
    ],
  };

  const SESSION_REPORT_FIELDS = [
    {
      columns: { small: 1, large: 1 },
      fields: [
        {
          type: 'textarea',
          name: 'sessionReportBody',
          label: isCanceled
            ? `Include a note to ${fullName}`
            : `Include a session report to ${fullName}`,
          placeholder: 'This will be sent to clients and visible to admins.',
        },
      ],
    },
    {
      columns: { small: 1, large: 1 },
      fields: [
        {
          type: 'textarea',
          name: 'internalNotes',
          label: 'Internal Note (visible only to your admin)',
          placeholder: 'If your sessions go over, be sure to note it here',
        },
      ],
    },
  ];

  // $FlowFixMe
  const formatedFields = compact([
    showSessionReportRatingField && !isCanceled && RATINGS_FIELD,
    ...SESSION_REPORT_FIELDS,
  ]);

  const FIELD_SETS = [
    {
      fieldSet: formatedFields,
    },
  ];

  return {
    HEADLINE,
    FIELD_SETS,
  };
};

export default formatCreateReport;



// WEBPACK FOOTER //
// ./src/containers/sessions/create/report/fieldset.js